import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=0c381784&"
import script from "./Socials.vue?vue&type=script&lang=js&"
export * from "./Socials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports